<template>
    <div id="insurance_policy_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="noDataFound === false">
        <div class="web-right-sidebar">
            <div class="right-asset-tab-list">
                <ul class="activetabs" id="tabActive">
                    <li v-bind:class="[ activetab === 1 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=1" >Insurance Detail</a></li>
                    <li v-if="canAddPolicyComment" v-bind:class="[ activetab === 5 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=5,loadComments('load')">Comments</a></li>
                    <li v-bind:class="[ activetab === 2 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=2">Attachment</a></li>
                    <li v-bind:class="[ activetab === 3 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=3">Insurance Limit</a></li>
                    <li v-bind:class="[ activetab === 4 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=4">Applicable Unit</a></li>
                    <li v-bind:class="[ activetab === 6 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="getActivityLog()">Activity Logs</a></li>
                </ul>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area left-asset-detail-section">
            <template v-if="cantAccessPage === true">
                <div class="page-name asset-view-page-name">
                    <div class="page-title"> Insurance Details</div>
                        <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <button type="submit" v-if="activetab === 1 && canAddPolicy" class="btn btn-primary" v-on:click.prevent="updateInsurance" >
                            <i class="fp-edit-icon"> </i> Edit
                        </button>
                    <button type="submit" class="btn btn-secondary" v-on:click.prevent="renewPolicy" v-if="self_insured.toLowerCase() == 'no' && canAddPolicy">
                        Renew Policy
                    </button>
                    <button type="submit" class="btn btn-secondary" v-on:click.prevent="changeStatus" v-if="status.toLowerCase() == 'pending' && canApprovePolicy">
                        Approve
                    </button>
                    <button type="submit" class="btn btn-secondary" v-on:click.prevent="goPreviousPath" >
                        <i class="fp-back"> </i>    Back
                    </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div id="customer-detail" class="admin-page-content insurance-policy-view list-view">
                        <section class="internal-container border-top-table-fl">
                            <div class="list-sections" v-if="activetab == 1">
                                <div class="form-row no-divider">
                                    <div class="col-md-6" v-if="self_insured.toLowerCase() == 'yes'">
                                        <div class="row form-group">
                                            <label class="col">Policy Number: </label>
                                            <span class="col"> {{policy_number}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Policy Ownership: </label>
                                            <span class="col"> {{titleCase(policy_owner)}} </span>
                                        </div>
                                        <div class="row form-group" v-if="customer != null && customer != ''">
                                            <label class="col">Customer:</label>
                                            <template v-if="whole_customer != ''">
                                                <span class="col" v-fp-html="whole_customer"></span>
                                            </template>
                                            <template v-else>
                                                <span class="col"> {{customer}} </span>
                                            </template>
                                        </div>
                                        <!-- <div class="row form-group">
                                            <label class="col">Insurance Policy Type:</label>
                                            <span class="col">{{titleCase(insurance_policy_type)}} </span>
                                        </div> -->
                                        <div class="row form-group">
                                            <label class="col">Self Insured For:</label>
                                            <span class="col">{{titleCase(self_insured_for)}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Review Date:</label>
                                            <span class="col">{{review_date}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Policy Type:</label>
                                            <span class="col" v-if="is_rental_blanket == 1">Blanket Policy </span>
                                            <span class="col" v-else>Schedule Policy </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Is National Lease:</label>
                                            <span class="col" v-if="is_national_lease == 1">Yes </span>
                                            <span class="col" v-else>No</span>
                                        </div>
                                        <!-- <div class="row form-group">
                                            <label class="col">Comment:</label>
                                            <span class="col">{{comment}} </span>
                                        </div> -->
                                    </div>
                                    <div class="col-md-6" v-if="self_insured.toLowerCase() == 'no'">
                                        <div class="row form-group">
                                            <label class="col">Policy Number: </label>
                                            <span class="col"> {{policy_number}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Policy Ownership: </label>
                                            <span class="col"> {{titleCase(policy_owner)}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Customer:</label>
                                            <template v-if="whole_customer != ''">
                                                <span class="col" v-fp-html="whole_customer"></span>
                                            </template>
                                            <template v-else>
                                                <span class="col"> {{customer}} </span>
                                            </template>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Start Date:</label>
                                            <span class="col">{{start_date}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Expiry Date:</label>
                                            <span class="col">{{expiry_date}} </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Self Insured:</label>
                                            <span class="col">{{self_insured}} </span>
                                        </div>
                                        <template v-if="self_insured.toLowerCase() == 'yes'">
                                            <div class="row form-group">
                                                <label class="col">Self Insured For:</label>
                                                <span class="col">{{titleCase(self_insured_for)}} </span>
                                            </div>
                                        </template>
                                        <div class="row form-group">
                                            <label class="col">Actual Cash Value:</label>
                                            <span class="col" v-if="actual_cash_value==0">No</span>
                                            <span class="col" v-else>Yes</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Is National Lease:</label>
                                            <span class="col" v-if="is_national_lease == 1">Yes </span>
                                            <span class="col" v-else>No</span>
                                        </div>
                                        <!-- <div class="row form-group">
                                            <label class="col">Comment:</label>
                                            <span class="col">{{comment}}</span>
                                        </div> -->
                                        <div class="row form-group">
                                            <label class="col">Status:</label>
                                            <span class="col">{{status}}</span>
                                        </div>
                                        <!-- <div class="row form-group">
                                            <label class="col">Insurance Policy Type:</label>
                                            <span class="col">{{titleCase(insurance_policy_type)}} </span>
                                        </div>     -->
                                    </div>
                                    <div class="col-md-6 right-customer-view" v-if="self_insured.toLowerCase() == 'no'">
                                        <div class="row form-group">
                                            <label class="col">Insurance Company:</label>
                                            <span class="col">  {{insurance_company}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Insurance Agency:</label>
                                            <span class="col">  {{insurance_agency}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Rental Policy Type:</label>
                                            <span class="col" v-if="is_rental_blanket == 1">Blanket Policy </span>
                                            <span class="col" v-else-if="is_rental_blanket == 0">Schedule Policy </span>
                                            <span class="col" v-else-if="is_rental_blanket == 2">Not Applied </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Lease Policy Type:</label>
                                            <span class="col" v-if="is_lease_blanket == 1">Blanket Policy </span>
                                            <span class="col" v-else-if="is_lease_blanket == 0">Schedule Policy </span>
                                            <span class="col" v-else-if="is_lease_blanket == 2">Not Applied </span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Insurance Policy For:</label>
                                            <span class="col">{{titleCase(insurance_policy_type)}}</span>
                                        </div>
                                        <!-- <div class="row form-group">
                                            <label class="col">Credit Limit:</label>
                                            <span class="col">{{numberFormat(credit_limit)}} </span>
                                        </div> -->
                                        <div class="row form-group">
                                            <label class="col">Approved By :</label>
                                            <span class="col">{{approved_by_credit}}</span>
                                        </div>
                                        <!-- <div class="row form-group">
                                            <label class="col">Status:</label>
                                            <span class="col">{{status}}</span>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="list-sections mb-5" v-if="activetab == 2">
                                <h5> Attachment </h5>
                                <template v-if="files.length > 0">
                                    <template v-for="(doc,vkey) in files">
                                        <div v-bind:key="'fileDiv'+vkey" class="attachment-list">
                                            <i v-if="doc.extension == 'pdf'" class="fp-pdf-icon"></i>
                                            <i v-if="doc.extension == 'doc' || doc.extension == 'docs'" class="fp-text-document"></i>
                                            <i v-if="doc.extension == 'jpg' ||  doc.extension == 'png' ||  doc.extension == 'jpeg' " class="fp-image"></i>
                                            <a :key="vkey" href="javascript:void(0)" class="col" v-on:click="openDocument(doc.url,doc.extension)">  {{doc.display_name}}</a>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <span>No attachments found</span>
                                </template>
                            </div>
                            <div class="list-sections mb-5" id="customer-detail" v-if="activetab == 3">
                                <h5>Insurance Limit</h5>
                                <template v-if="self_insured.toLowerCase() == 'no' && showInsuranceLimit">
                                    <div class="table-responsive-sm">
                                    <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>Section</th>
                                                <th>Description</th>
                                                <th>Deductible (Dollars)</th>
                                                <th>Liability (Millions $)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="(self_insured.toLowerCase() == 'no' && (insurance_policy_type == 'liability' || insurance_policy_type == 'both')) || (self_insured.toLowerCase() == 'yes' && insurance_policy_type == 'physical')">
                                                <tr>
                                                    <td> LIAB</td>
                                                    <td>Liability</td>
                                                    <td style="text-align:right" v-if="(insurance_policy_type == 'liability' || insurance_policy_type == 'both')">{{numberFormat(liabilityDeductible)}}</td>
                                                    <td style="text-align:right" v-else> - </td>
                                                    <td style="text-align:right">{{numberFormat(liability)}}</td>
                                                </tr>
                                            </template>
                                            <template v-if="(self_insured.toLowerCase() == 'no' && (insurance_policy_type == 'physical' || insurance_policy_type == 'both')) || (self_insured.toLowerCase() == 'yes' && insurance_policy_type == 'liability')">
                                                <tr>
                                                    <td> COMP</td>
                                                    <td>Comprehensive</td>
                                                    <td style="text-align:right"> {{numberFormat(comprehensive)}} </td>
                                                    <td style="text-align:right"> - </td>
                                                </tr>
                                            </template>
                                            <template v-if="(self_insured.toLowerCase() == 'no' && (insurance_policy_type == 'physical' || insurance_policy_type == 'both')) || (self_insured.toLowerCase() == 'yes' && insurance_policy_type == 'liability')">
                                                <tr>
                                                    <td> COLL</td>
                                                    <td>Collision</td>
                                                    <td style="text-align:right"> {{numberFormat(collision)}} </td>
                                                    <td style="text-align:right"> - </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                    </div>
                                </template>
                                <template v-else>
                                    <p>No Data found.</p>
                                </template>
                            </div>
                            <div class="list-sections mb-5" id="customer-detail" v-if="activetab == 4">
                                <h5>Applicable Unit</h5>
                                <div class="table-responsive-sm">
                                    <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>Unit</th>
                                                <th>Serial Number</th>
                                                <th>Date Added</th>
                                                <th>Date Cancelled</th>
                                                <th>Type</th>
                                                <th>Actual Cash Value</th>
                                                <th>Credit Limit</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="assetArr != undefined && assetArr.length > 0">
                                            <tr v-for="(asset, index2) in assetArr" v-bind:key="index2">
                                                <td>{{ asset.unit_no.text }}</td>
                                                <td>{{ asset.vin }}</td>
                                                <td>{{ asset.date_added }}</td>
                                                <td v-if="asset.date_cancelled">{{ asset.date_cancelled}}</td>
                                                <td v-else>-</td>
                                                <td>{{ titleCase(asset.type) }}</td>
                                                <td v-if="asset.isACV == 0">No</td>
                                                <td v-else>Yes</td>
                                                <td v-if="asset.credit_limit" class="text-right">{{ numberFormat(asset.credit_limit)}}</td>
                                                <td v-else>-</td>
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="5" class="text-center">No record found.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div id="customer-detail" v-if="activetab == 5" class="list-sections mb-5">
                                <template v-if="addCommentEnabled">
                                    <div class="form-row row-cols-md-1 row-cols-1">
                                        <div class="col form-group">
                                            <label class="control-label require" for="comment_type_id">Select Type:</label>
                                            <v-select v-model="comment_type_id" name="comment_type_id" placeholder="Select Comment Type" label="text" :options="commentTypeArr">
                                            </v-select>
                                            <div class="field-error">{{ comment_type_error_msg }}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label require" for="exampleFormControlTextarea2">Comment:</label>
                                            <textarea class="form-control" v-model="pcomment" ref="textarea" id="exampleFormControlTextarea2" rows="3" v-on:keyup="process($event)"></textarea>
                                            <div class="field-error">{{ comment_error_msg }}</div>
                                        </div>
                                    </div>
                                    <div class="btn-groups">
                                        <button v-on:click="addComment(pcomment, comment_type_id)" class="btn btn-primary"> <i class="fp-save"> </i>Save</button>
                                        <button v-on:click="addCommentEnabled = false" class="btn btn-tertiary"> <i class="fp-close"> </i>Cancel</button>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="table-responsive-sm">
                                        <template v-if="commentArr && commentArr.length">
                                            <table aria-describedby="table" id="unit_table" class="table table-sm table-bordered">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th>Date</th>
                                                        <th>Comment Type</th>
                                                        <th>Comment</th>
                                                        <th>Comment By</th>
                                                        <th class="text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-if="commentArr && commentArr.length > 0">
                                                        <template v-for="(comment,ind) in commentArr">
                                                            <tr v-bind:key="'recordRow'+ind">
                                                                <td>{{ comment.comment_at }}</td>
                                                                <td>{{comment.comment_type}}</td>
                                                                <td><span v-fp-html="comment.comment"></span></td>
                                                                <td>{{comment.comment_by}}</td>
                                                                <td class="text-center"><a v-if="loggedInUser == comment.userId" href="javascript:void(0)" v-on:click="editComment(comment.comment_id, comment.comment_type_id, comment.comment_type,comment.comment)"><i class="fp-edit-icon" /></a></td>
                                                            </tr>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <tr><td colspan="5" class="text-center">No Record Found</td></tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </template>
                                        <template v-else>
                                            <p class="no-data-field"> No comment available </p>
                                        </template>
                                    </div>
                                </template>
                                <button type="submit" class="btn btn-primary pull-right" v-on:click="addCommentBox()" v-if="!addCommentEnabled">
                                    <i class="fp-add"></i>Add
                                </button>
                            </div>
                            <div id="activity-logs" class="mb-5" v-show="activetab == 6"> <!--Activity Logs-->
                                <policy-activity-log-list :activityLogVal="activityLogsTabValue"></policy-activity-log-list>
                            </div>
                        </section>
                        <template v-if="renewInsurancePolicy">
                            <div class="policyrenew wo-vendorinv-form">
                                <insurance-policy-renew :id="'renewInsurancePolicyForm'" :start_date="start_date" :expiry_date="expiry_date" class="policyrenew wo-vendorinv-panel"></insurance-policy-renew>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
        </template>
        <template v-else-if="noDataFound === true">
            <template v-if="cantAccessPage === true">
                <div id="page-content-wrapper" class="admin-content-area">
                    <div class="page-name">
                        <div class="page-title"> Insurance Details</div>
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <div class="btn-groups text-right">
                            <button type="submit" v-if="activetab === 1" class="btn btn-primary" v-on:click.prevent="updateInsurance" >
                                <i class="fp-edit-icon"> </i> Edit
                            </button>
                            <button type="submit" class="btn btn-secondary" v-on:click.prevent="goPreviousPath" >
                                <i class="fp-back"> </i>    Back
                            </button>
                        </div>
                    </div>
                    <div class="container-fluid">
                        <div class="bg-white text-center">
                            <div class="error-details">
                                No Data Found or Insurance Policy Removed.
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </template>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';

import {contractMixins} from '../../mixins/contractMixins';
import InsurancePolicyRenew from '@/components/insurance/InsurancePolicyRenew.vue';
Vue.component("insurance-policy-renew", InsurancePolicyRenew);
export default {
  name: "InsurancePolicyView",
  components: {
        
        PolicyActivityLogList: () => import('@/components/ActivityLogList.vue'),
    },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    activetab:1,
    insurance_company:'',
    policy_number: "",
    policy_owner:"",
    customer :'',
    start_date:"",
    expiry_date:"",
    cancel_date:"",
    insurance_agency:'',
    insuranceAgencyArr:[],
    insuranceCompanyArr:[],
    loading:false,
    is_rental_blanket:0,
    liability:"",
    liabilityDeductible:"",
    comprehensive:"",
    collision:"",
    files:[],
    liability_error_msg:"",
    comprehensive_error_msg:"",
    collision_error_msg:"",
    loadOnce:false,
    vehicleArr:[],
    assetArr:[],
    idArr:[],
    removeSign:false,
    docPath:process.env.FOLDER_URL +"/insurancedocs/",
    pageKey:"",
    comment:"",
    self_insured:"",
    insurance_policy_type:"",
    self_insured_for:"",
    showInsuranceLimit:false,
    credit_limit:"",
    approved_by_credit:"",
    commentTypeArr:[],
    commentArr:[],
    comment_type_error_msg:'',
    comment_error_msg:'',
    commentLoadOnce:false,
    addCommentEnabled:false,
    comment_type_id:'',
    pcomment:'',
    commentId:0,
    canAddPolicyComment:false,
    loggedInUser:0,
    actual_cash_value:"",
    status:"",
    whole_customer:"",
    renewInsurancePolicy:false,
    tabMenuArray:[],
    activityLogsTabValue: "dontLoadList",
    review_date:"-",
    is_national_lease:0,
    noDataFound:"",
    canApprovePolicy:false,
    canAddPolicy:false,
    is_lease_blanket:0
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'view_insurance_policies') {
                        self.cantAccessPage = true;
                    } else if (permissions[i].name == 'add_insurance_policy_comment') {
                        self.canAddPolicyComment = true;
                    } else if (permissions[i].name == 'can_approve_insurance_policy') {
                        self.canApprovePolicy = true;
                    } else if (permissions[i].name == 'add_insurance_policies') {
                        self.canAddPolicy = true;
                    }

                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['policy_comment']);
        var path = window.location.pathname;
        var segments = path.split("/");
        setTimeout(function () {
            if (segments[3]) {
                self.loadInsurancePolicy();
            }
        }, 100);
        self.pageKey='_insurance_policy_view_'+segments[3];

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            // var userJson = JSON.parse(userObj);
            self.loggedInUser = userObj["id"];
        }

  },
  metaInfo() {
    return {
        title: (this.policy_number != "") ? this.policy_number + " | Insurance Policy View | " +process.env.COPYRIGHT_NAME:"Insurance Policy View | " +process.env.COPYRIGHT_NAME
    }
  },
  methods: {

    BackInsurancePolicyList() {
      var self = this;
      self.$router.push("/insurancepolicy/list");
    },

    loadInsurancePolicy() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/insurancepolicy/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.noDataFound = false;
                    self.insurance_company  = data.content.icCode + " | " + data.content.icName;
                    self.policy_number = data.content.policy_number;
                    self.policy_owner = data.content.policy_owner;
                    var storeObject={visited_page: {
                                    path : "InsurancePolicy |" +data.content.policy_number,
                                    data : window.location.pathname,
                                    }};
                    self.getRecentlyPagesMethod(storeObject);
                    self.customer = data.content.cusCode + " | " + data.content.cusName;
                    self.start_date = data.content.start_date;
                    self.expiry_date = data.content.expiry_date;
                    self.cancel_date = data.content.cancel_date;
                    if(data.content.iaName != null){
                        var agencyText = "";
                        if (data.content.iaCode != null) {
                            agencyText = data.content.iaCode + " | " + data.content.iaName;
                        }else{
                            agencyText = data.content.iaName;
                        }
                        if (data.content.address_line_1 != null && data.content.address_line_1 != "") {
                            agencyText += " | ";
                            agencyText += data.content.address_line_1;
                        }
                        if (data.content.agency_city != null && data.content.agency_city != "") {
                            agencyText += " | ";
                            agencyText += data.content.agency_city;
                        }
                        self.insurance_agency = agencyText;
                    }else{
                        self.insurance_agency = '';
                    }
                    self.liability = data.content.liability;
                    self.liabilityDeductible = data.content.liability_deductible;
                    self.comprehensive = data.content.comprehensive;
                    self.collision = data.content.collision;
                    self.status = data.content.status.charAt(0).toUpperCase() + data.content.status.slice(1);
                    self.is_rental_blanket = data.content.is_rental_blanket;
                    self.is_lease_blanket = data.content.is_lease_blanket;
                    if(data.content.doc_path != null){
                        self.files = data.content.doc_path;
                    }
                    self.assetArr = [];    
                    if(data.content.mapper_data && data.content.mapper_data.length > 0){

                        self.assetArr = data.content.mapper_data;

                        if ( self.assetArr != undefined && self.assetArr.length > 0 ) {

                            self.removeSign = true;
                        }
                    }
                    if (data.content.comment != null) {
                        self.comment = data.content.comment;
                    }else{
                        self.comment = "-";
                    }
                    self.insurance_policy_type = data.content.policy_type;
                    if (data.content.self_insured != null) {
                        self.self_insured = "Yes";
                        self.self_insured_for = data.content.self_insured;
                        if (data.content.self_insured == "physical" || data.content.self_insured == "liability") {
                            self.showInsuranceLimit = true;
                        }
                    }else{
                        self.self_insured = "No";
                        self.showInsuranceLimit = true;
                    }
                    // if (data.content.is_rental_blanket == 1) {
                        self.credit_limit = data.content.credit_limit;
                        self.actual_cash_value = data.content.actual_cash_value;
                    // }
                    if (data.content.approved_by_credit == 1) {
                        self.approved_by_credit = "Yes";
                    }else{
                        self.approved_by_credit = "No";
                    }
                    if (data.content.whole_customer != undefined) {
                        if (data.content.whole_customer != null) {
                            self.whole_customer = data.content.whole_customer;
                        }
                    }
                    if (data.content.review_date != undefined) {
                        if (data.content.review_date != null) {
                            self.review_date = data.content.review_date;
                        }
                    }
                    if (data.content.is_national_lease != undefined && data.content.is_national_lease != null) {
                        self.is_national_lease = data.content.is_national_lease;
                    }
                }else{
                    if (data.code == 201) {
                        self.noDataFound = true;
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'insurance-policy-get-by-id')
            }
        });
    },

    removeUnit:function(id){

        var self = this;
        var data = self.idArr;

        if (confirm('Are you sure that you want to delete this Insurance Unit? ')) {
            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/remove_mapper_unit",
                type: "POST",
                data: {
                    id:id
                },
                dataType: "json",
                headers: this.ajxHeaders,
                success: function(data) {
                    self.loading=false;

                    if (data.status == "success") {

                        self.loadInsurancePolicy();
                    }
                },
                error: function(jqXHR, exception) {
                    self.loading=false;

                    self.generateStatusCodeMessage(jqXHR,true,'insurance-policy-remove-unit')
                }
            });
        }
    },

    updateInsurance (){

        var self = this;
        var id =  self.$route.params.id;

        self.$router.push("/insurancepolicy/edit/"+id);
    },
    addComment: function(comment,typeId){
        var self = this;
        var error = false;
        var path = window.location.pathname;
        var segments = path.split("/");
        self.comment_type_error_msg = '';
        self.comment_error_msg = '';
        if (typeId == null || !typeId.value){
            self.comment_type_error_msg = 'Comment Type Required';
            error = true;
        }
        if (comment == ''){
            self.comment_error_msg = 'Comment Required';
            error = true;
        }

        if (!error){

            $.ajax({
                url: process.env.ROOT_API + "/policy-comment/store",
                type: "POST",
                headers: this.ajxHeaders,
                data:{
                    comment:comment,
                    type:typeId.value,
                    comment_id:self.commentId,
                    policy_id:segments[3]
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    if (data.status == "success") {
                        self.pcomment = '';
                        self.comment_type_id = '';
                        self.loadComments('save');
                        self.addCommentEnabled = false;
                        self.commentId = 0;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'insurance-policy-comment-store')
                }
            });
        }
    },
    loadComments:function(flag){
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        if (flag == 'load' && self.commentLoadOnce){
            return;
        }
        self.commentLoadOnce = true;
        $.ajax({
            url: process.env.ROOT_API + "/policy-comment/fetch/"+segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.commentArr = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'insurance-policy-comment-store')
            }
        });
    },

    saveId(evt,id){
        var self = this;

        console.log(evt.target.checked);
        if(evt.target.checked == true){
            self.idArr.push({id:id});
        }else{
            var i = self.idArr.indexOf(id);
            const filteredItems = self.idArr.filter(function(item) {
                return item.id !== id
            })
            self.idArr = filteredItems;
        }
    },

    splitString(string){

        var str = string.split('-');

        if(str[1]){

            return str[1].charAt(0).toUpperCase() + str[1].slice(1);
        }
    },
    numberFormat(amount){

        return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    },
    editComment(id,typeId,comment_type,comment){
        var self = this;
        self.pcomment = comment;
        self.comment_type_id = {text:comment_type,value:typeId};
        self.commentId = id;
        self.addCommentEnabled = true;
    },
    addCommentBox(){
        var self = this;
        self.addCommentEnabled = true;
        self.comment_type_id = '';
        self.pcomment = '';
    },
    renewPolicy() {
        var self = this;
        self.renewInsurancePolicy = true;
    },
    getActivityLog(){
      var self = this;
      self.activetab = 6;
      var path = window.location.pathname;
      var segments = path.split("/");
      if(!self.tabMenuArray.includes(self.activetab)){
        // self.tabMenuArray.push(self.activetab);
        this.$root.$emit('activity_log_opted','insurance policies',segments[3]);
        self.activityLogsTabValue = "loadList";   // flag value set to loadList so that filters in list work properly.
      }
    },
    refreshActivityLog() {
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        self.$root.$emit('activity_log_opted','insurance policies',segments[3]);//refresh activity log
    },
    changeStatus:function(){
        var self = this;
        self.loading =true;
        $.ajax({
            url: process.env.ROOT_API + "/policy-status/change",
            type: "POST",
            headers: this.ajxHeaders,
            data:{
                id:self.$route.params.id
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.$swal('',data.message,'success');
                    self.loadInsurancePolicy();
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'insurance-policy-comment-store')
            }
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/insurance/InsurancePolicyView.vue